import { Link, useLocation } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  const location = useLocation();

  useDocumentMeta({
    title: "页面未找到 - 91视频网站",
    description:
      "抱歉，你访问的页面不存在或已被移除。返回91视频网站首页，继续浏览热门电影、电视剧与综艺资源。",
    keywords: "91视频网站,页面未找到,影视资源",
    canonicalPath: "/",
  });

  return (
    <div className="w-full px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto flex max-w-xl flex-col items-center text-center">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-50 text-primary-400">
          <i className="ri-emotion-sad-line text-4xl" aria-hidden="true"></i>
        </span>
        <p className="mt-6 font-heading text-5xl font-extrabold text-primary-500">404</p>
        <h1 className="mt-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          抱歉，你访问的页面不存在
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-foreground-500">
          页面可能已被移除、更名，或链接输入有误。试试回到首页，继续发现好看的影视内容吧。
        </p>
        <p className="mt-2 break-all font-mono text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line" aria-hidden="true"></i>
            返回首页
          </Link>
          <Link
            to="/search"
            className="rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer whitespace-nowrap"
          >
            去搜索影视
          </Link>
        </div>
      </div>
    </div>
  );
}